import React from 'react'
import { Col, Row, Modal, ModalBody, FormGroup, Label } from 'reactstrap'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { getStaticImage } from 'utils/statics'

import shortenAPI from 'api/shorten'
import './stylesButton.scss'
import { Button } from '..'
import { lang } from 'utils/helpers'

const ModalButtons = ({ isOpenModal, setIsOpenModal, templateButtons, setTemplateButtons }) => {
  const [errorFromShortener, setErrorFromShortener] = React.useState({ name: null, error: false })
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const shortenUrl = async (target, setFieldValue, onSave) => {
    const data = { urls: [target.value] }
    return new Promise((resolve, reject) => {
      if (data.urls[0].length > 0) {
        shortenAPI
          .shortenUrl(data)
          .then(({ status, data }) => {
            if (status === 200) {
              setErrorFromShortener({ ...{ name: target.name, error: false, [target.name]: data.result[0].url } })
              setFieldValue(target.name, data.result[0].url)
              return resolve(data.result[0].url)
            } else {
              !onSave && setErrorFromShortener({ ...{ name: target.name, error: true } })
              return resolve('error')
            }
          })
          .catch((err) => {
            !onSave && setErrorFromShortener({ ...{ name: target.name, error: true, [target.name]: null } })
            return resolve('error')
          })
      }
      else {
        setErrorFromShortener({ ...{ name: target.name, error: false } })
        return resolve(false)
      }
    })
  }

  const handleOnSave = async (values, props) => {
    setIsSubmitting(true)
    const _values = values
    const content1 = await shortenUrl({ name: 'content1', value: values[`content1`] }, props.setFieldValue, true)
    const content2 = await shortenUrl({ name: 'content2', value: values[`content2`] }, props.setFieldValue, true)
    const content3 = await shortenUrl({ name: 'content3', value: values[`content3`] }, props.setFieldValue, true)
    setIsSubmitting(false)

    if (content1 === 'error') {
      setErrorFromShortener({ ...{ name: 'content1', error: true } })
      return false
    }
    else if (content1)
      _values['content1'] = content1
    if (content2 === 'error') {
      setErrorFromShortener({ ...{ name: 'content2', error: true } })
      return false
    }
    else if (content2)
      _values['content2'] = content2
    if (content3 === 'error') {
      setErrorFromShortener({ ...{ name: 'content3', error: true } })
      return false
    }
    else if (content3)
      _values['content3'] = content3

    const buttons = [1, 2, 3]
      .filter((n) => !!_values[`label${n}`])
      .map((n) => ({
        type: 'url', // Values: url, callback, loginUrl
        label: _values[`label${n}`], // Button text to show
        content: _values[`content${n}`], // URL, or action to execute
      }))
    setTemplateButtons(buttons)
    setIsOpenModal() //(false)
  }

  const setErrors = (buttons) => {
    const errors = {}

    if (buttons.label1 && !buttons.content1) errors.content1 = lang('dashboard_errors_required-field')
    if (buttons.content1 && !buttons.label1) errors.label1 = lang('dashboard_errors_required-field')
    if (buttons.content1 && errorFromShortener.name === 'content1' && errorFromShortener.error) {
      errors.content1 = lang('dashboard_error_url-not-valid')
    }

    if (buttons.label2 && !buttons.content2) errors.content2 = lang('dashboard_errors_required-field')
    if (buttons.content2 && !buttons.label2) errors.label2 = lang('dashboard_errors_required-field')
    if (buttons.content2 && errorFromShortener.name === 'content2' && errorFromShortener.error) {
      errors.content2 = lang('dashboard_error_url-not-valid')
    }

    if (buttons.label3 && !buttons.content3) errors.content3 = lang('dashboard_errors_required-field')
    if (buttons.content3 && !buttons.label3) errors.label3 = lang('dashboard_errors_required-field')
    if (buttons.content3 && errorFromShortener.name === 'content3' && errorFromShortener.error) {
      errors.content3 = lang('dashboard_error_url-not-valid')
    }

    return errors
  }

  const removeButtons = (formikProps) => {
    formikProps.setFieldValue('label1', '')
    formikProps.setFieldValue('content1', '')
    formikProps.setFieldValue('label2', '')
    formikProps.setFieldValue('content2', '')
    formikProps.setFieldValue('label3', '')
    formikProps.setFieldValue('content3', '')
  }

  const removeButton = (formikProps, item) => {
    if (item) {
      formikProps.setFieldValue(`label${item}`, '')
      formikProps.setFieldValue(`content${item}`, '')
    }
  }

  return (
    <Modal isOpen={isOpenModal} centered={true} toggle={() => setIsOpenModal(!isOpenModal)} className='modal-md' contentClassName={'modal-content-buttons'} id='modalButtons'>
      <Formik
        key={'modalButtons'}
        initialValues={Object.assign(
          {},
          {
            label1: (templateButtons.length >= 1 && templateButtons[0].label) || '',
            content1: (templateButtons.length >= 1 && templateButtons[0].content) || '',
            label2: (templateButtons.length >= 2 && templateButtons[1].label) || '',
            content2: (templateButtons.length >= 2 && templateButtons[1].content) || '',
            label3: (templateButtons.length === 3 && templateButtons[2].label) || '',
            content3: (templateButtons.length === 3 && templateButtons[2].content) || '',
          }
        )}
        validate={setErrors}
        onSubmit={handleOnSave}
        validateOnBlur={true}
      >
        {(formikProps) => (
          <Form noValidate>
            <div className='modal-wrapper-header'>
              <h1>{lang('dashboard_add-buttons')}</h1>
              <span onClick={() => setIsOpenModal(!isOpenModal)}>
                <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
              </span>
            </div>
            <ModalBody>
              <Row>
                <Col>
                  <legend>{lang('dashboard_max-buttons-reply')}</legend>
                </Col>
              </Row>

              <Row>
                <Col className='my-1'>
                  <h5>{`${lang('dashboard_button')} 1`}</h5>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for='label1'>{lang('dashboard_title')}</Label>
                        <Field className='form-control' type='text' name='label1' id='label1' placeholder={lang('dashboard_title')} />
                        <ErrorMessage name='label1' component='small' className='text-danger' />
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label for='content1'>{lang('dashboard_url')}</Label>
                        <div className='input-with-icon'>
                          <Field
                            className='form-control'
                            type='url'
                            name='content1'
                            id='content1'
                            placeholder={lang('dashboard_url')}
                            onBlur={(e) => shortenUrl(e.target, formikProps.setFieldValue)}
                            onChange={({ target }) => {formikProps.setFieldValue(target.name, target.value); setErrorFromShortener({ ...{ name: 'content1', error: false } })}}
                          />
                          <span className='delete-button' onClick={() => removeButton(formikProps, 1)}>
                            <i className='fa fa-times px-2' />
                          </span>
                        </div>
                        <ErrorMessage name='content1' component='small' className='text-danger' />
                        {errorFromShortener.name === 'content1' && errorFromShortener.error && !formikProps.errors['content1'] && (
                          <small name='content1Url' className='text-danger'>
                            {lang('dashboard_error_url-not-valid')}
                          </small>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col className='my-1'>
                  <h5>{`${lang('dashboard_button')} 2 (${lang('dashboard_optional')})`}</h5>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for='label2'>{lang('dashboard_title')}</Label>
                        <Field className='form-control' type='text' name='label2' id='label2' placeholder={lang('dashboard_title')} />
                        <ErrorMessage name='label2' component='small' className='text-danger' />
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label for='content2'>{lang('dashboard_url')}</Label>
                        <div className='input-with-icon'>
                          <Field
                            className='form-control'
                            type='url'
                            name='content2'
                            id='content2'
                            placeholder={lang('dashboard_url')}
                            onBlur={(e) => shortenUrl(e.target, formikProps.setFieldValue)}
                            onChange={({ target }) => {formikProps.setFieldValue(target.name, target.value); setErrorFromShortener({ ...{ name: 'content2', error: false } })}}
                          />
                          <span className='delete-button' onClick={() => removeButton(formikProps, 2)}>
                            <i className='fa fa-times px-2' />
                          </span>
                        </div>
                        <ErrorMessage name='content2' component='small' className='text-danger' />
                        {errorFromShortener.name === 'content2' && errorFromShortener.error && !formikProps.errors['content2'] && (
                          <small name='content2Url' className='text-danger'>
                            {lang('dashboard_error_url-not-valid')}
                          </small>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col className='my-1'>
                  <h5>{`${lang('dashboard_button')} 3 (${lang('dashboard_optional')})`}</h5>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label for='label3'>{lang('dashboard_title')}</Label>
                        <Field className='form-control' type='text' name='label3' id='label3' placeholder={lang('dashboard_title')} />
                        <ErrorMessage name='label3' component='small' className='text-danger' />
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label for='content3'>{lang('dashboard_url')}</Label>
                        <div className='input-with-icon'>
                          <Field
                            className='form-control'
                            type='url'
                            name='content3'
                            id='content3'
                            placeholder={lang('dashboard_url')}
                            onBlur={(e) => shortenUrl(e.target, formikProps.setFieldValue)}
                            onChange={({ target }) => {formikProps.setFieldValue(target.name, target.value); setErrorFromShortener({ ...{ name: 'content3', error: false } })}}
                          />
                          <span className='delete-button' onClick={() => removeButton(formikProps, 3)}>
                            <i className='fa fa-times px-2' />
                          </span>
                        </div>
                        <ErrorMessage name='content3' component='small' className='text-danger' />
                        {errorFromShortener.name === 'content3' && errorFromShortener.error && !formikProps.errors['content3'] && (
                          <small name='content3Url' className='text-danger'>
                            {lang('dashboard_error_url-not-valid')}
                          </small>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ModalBody>
            <div className='footer-buttons'>
              <div className='save-cancel'>
                <Button
                  value={lang('dashboard_save')}
                  secondary
                  onClick={formikProps.handleSubmit}
                  isSubmitting={isSubmitting}
                />
                <Button
                  value={lang('dashboard_cancel')}
                  onClick={() => setIsOpenModal(false)}
                />
              </div>
              <Button
                value={lang('dashboard_delete-all')}
                remove
                onClick={() => removeButtons(formikProps)}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ModalButtons
